import { AuthActions, AuthState, USER_AUTH_TICKET, USER_LEGACY_TOKEN } from './types';

import { INITIALIZE_USER, LOGOUT, UserActions } from '../user/types';

const initialState: AuthState = {
  loggedIn: false,
  token: '',
};

export const authReducer = (state = initialState, action: AuthActions | UserActions): AuthState => {
  switch (action.type) {
    case INITIALIZE_USER:
      return {
        ...state,
        legacyToken: undefined,
        loggedIn: true,
      };

    case USER_LEGACY_TOKEN:
      return {
        ...state,
        legacyToken: action.token,
      };

    case LOGOUT:
      return initialState;

    case USER_AUTH_TICKET:
      return {
        ...state,
        token: action.token,
      };

    default:
      return state;
  }
};
